module.exports = __webpack_public_path__ + "img/773ee67.jpg";